<template>
  <footer
    class="site-beian-footer"
    :class="[
      `site-beian-footer--${tone}`,
      { 'site-beian-footer--fixed': fixed, 'site-beian-footer--compact': compact }
    ]"
  >
    <p class="site-beian-footer__line">
      <a
        class="site-beian-footer__link"
        :href="MIIT_BEIAN_HOME_URL"
        target="_blank"
        rel="noopener noreferrer"
      >{{ ICP_SITE_NUMBER }}</a>
      <template v-if="psbDisplay">
        <span class="site-beian-footer__sep" aria-hidden="true">|</span>
        <a
          class="site-beian-footer__link site-beian-footer__psb"
          :href="psbUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            class="site-beian-footer__psb-icon"
            src="https://www.beian.gov.cn/img/ghs.png"
            alt=""
            width="16"
            height="16"
          />
          <span>{{ psbDisplay }}</span>
        </a>
      </template>
    </p>
    <p v-if="showSubject" class="site-beian-footer__line site-beian-footer__subject">
      <span class="site-beian-footer__label">主体备案号：</span>
      <a
        class="site-beian-footer__link"
        :href="MIIT_BEIAN_HOME_URL"
        target="_blank"
        rel="noopener noreferrer"
      >{{ ICP_SUBJECT_NUMBER }}</a>
    </p>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import {
  MIIT_BEIAN_HOME_URL,
  ICP_SUBJECT_NUMBER,
  ICP_SITE_NUMBER,
  PSB_BEIAN_DISPLAY,
  PSB_BEIAN_RECORDCODE,
  buildPsbBeianUrl
} from '@/config/siteBeian'

defineProps({
  /** default：浅色底；on-dark：登录页等深色背景 */
  tone: {
    type: String,
    default: 'default',
    validator: (v) => ['default', 'on-dark'].includes(v)
  },
  fixed: { type: Boolean, default: false },
  compact: { type: Boolean, default: false },
  showSubject: { type: Boolean, default: true }
})

const psbDisplay = computed(() => String(PSB_BEIAN_DISPLAY || '').trim())
const psbUrl = computed(() => buildPsbBeianUrl(PSB_BEIAN_RECORDCODE))
</script>

<style scoped>
.site-beian-footer {
  flex-shrink: 0;
  text-align: center;
  padding: 10px 16px;
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
  background: #fafafa;
  border-top: 1px solid #ebeef5;
}

.site-beian-footer--compact {
  padding: 6px 12px;
  font-size: 11px;
}

.site-beian-footer--fixed {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  border-top: none;
  background: transparent;
}

.site-beian-footer--on-dark {
  color: rgba(255, 255, 255, 0.88);
  background: transparent;
  border-top: none;
}

.site-beian-footer--on-dark.site-beian-footer--fixed {
  padding-bottom: calc(10px + env(safe-area-inset-bottom, 0));
}

.site-beian-footer__line {
  margin: 0;
  max-width: 100%;
  word-break: break-all;
  overflow-wrap: anywhere;
}

.site-beian-footer__line + .site-beian-footer__line {
  margin-top: 4px;
}

.site-beian-footer__subject {
  font-size: 11px;
  opacity: 0.92;
}

.site-beian-footer__label {
  opacity: 0.85;
}

.site-beian-footer__sep {
  margin: 0 8px;
  opacity: 0.6;
}

.site-beian-footer__link {
  color: inherit;
  text-decoration: none;
}

.site-beian-footer__link:hover {
  text-decoration: underline;
}

.site-beian-footer--default .site-beian-footer__link {
  color: #606266;
}

.site-beian-footer--on-dark .site-beian-footer__link {
  color: rgba(255, 255, 255, 0.95);
}

.site-beian-footer__psb {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  vertical-align: middle;
  max-width: 100%;
  flex-wrap: wrap;
  justify-content: center;
}

.site-beian-footer__psb-icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
